<template>
  <div>
    <!-- 头部导航栏 -->
    <header v-show="maskSwitch == false">
      <div class="nav-bar">
        <div class="nav-box">
          <div class="logo">
            <img class="logo" src="../assets/log.png" />
          </div>
          <ul class="nav" v-for="(item, index) in menuList" :key="index">
            <li class="nav-list" @click="checkMenu(item.index)">
              <a :href="'#' + item.id">
                {{ item.title }}
              </a>
            </li>
          </ul>
          <div class="conect-btn" @click="maskSwitchBtn()">立即咨询</div>
        </div>
      </div>
    </header>
    <!-- 头部导航栏 -->
    <!-- 轮播 -->
    <div class="about">
      <el-carousel height="40.625rem">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div
            id="swiper1"
            class="swiper-container"
            style="height: 40.625rem; width: 120rem; margin-top: 4.375rem"
          >
            <div class="swiper-wrapper" id="1">
              <div
                class="swiper-slide"
                style="
                  width: 120rem;
                  height: 100%;
                  background-color: #38507e;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div class="s-content">
                  <div>
                    <div class="banner-title">{{ item.title }}</div>
                    <div class="banner-indroce">
                      {{ item.introduce }}
                    </div>
                    <div class="btn-group">
                      <div
                        :class="{
                          'ouer-btn': true,
                          xz: checkindex == 1,
                          wei: checkindex == 2,
                        }"
                        @mousemove="yiru(1)"
                        @mouseleave="yidong()"
                      >
                        我们的服务
                      </div>
                      <div
                        :class="{
                          'ouer-btn': true,
                          xz: checkindex == 2,
                          wei: checkindex == 1,
                        }"
                        @mousemove="yiru(2)"
                        @mouseleave="yidong()"
                        @click="maskSwitchBtn()"
                      >
                        联系我们
                      </div>
                    </div>
                  </div>
                  <div class="lunbo-img">
                    <img class="lunbo-img" :src="getImgUrl(item.image)" />
                  </div>
                </div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->

            <!-- 如果需要导航按钮 -->
            <!-- <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div> -->

            <!-- 如果需要滚动条 -->
            <!--   <div class="swiper-scrollbar"></div> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 我们的服务 -->
    <div style="width: 74rem; margin: auto; margin-top: 6.625rem" id="3">
      <div style="width: 24rem">
        <div class="serve-title">{{ service.name }}</div>
        <div class="serve-line"></div>
      </div>
    </div>
    <div class="our-serve">
      <div class="serve-left">
        <div class="servr-text">四川途乐多户外体育运动有限公司，成立于2019年，虽然坐落于天府之国成都，却致力于服务全国，是一家专注于定制软件研发及提供行业信息化解决方案的服务商 ,我们拥有从咨询、设计、开发、测试、运维到运营的全流程软件服务能力，为提高企业信息化建设而不断耕耘。</div>
        <div class="servr-text-grey">
          {{ firstServe[1] }}
        </div>
      </div>
      <div class="serve-right">
        <div
          class="serve-right-list"
          v-for="(item, index) in service.content"
          :key="index"
        >
          <img class="serve-right-list-icon" :src="getImgUrl(item.image)" />
          <div class="serve-right-list-text">
            <div class="serve-right-text-title">{{ item.title }}</div>
            <div class="serve-right-text-indrouce">{{ item.introduce }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- fuwu-->
    <div class="khfw" id="3">
      <div
        class="khfw-list"
        v-for="(item, index) in solve"
        :style="{ backgroundImage: `url(${getImgUrl(item.image)})` }"
        :key="index"
      >
        <img class="khfw-icon" :src="getImgUrl(item.background)" />
        <div class="line-khfw"></div>
        <div class="khfw-title">{{ item.title }}</div>
      </div>
    </div>
    <!-- 案例展示-->
    <div class="fwal-card" id="4">
      <div class="fwal-title">
        {{ contentInfo.ServiceCase ? contentInfo.ServiceCase.name : "" }}
      </div>
      <div class="line-fwal"></div>
      <p class="fwmw-text">
        {{ contentInfo.ServiceCase ? contentInfo.ServiceCase.introduce : "" }}
      </p>
      <div class="ywfw-ul">
        <div
          class="ywfw-tag"
          :class="fwfwIndex == index ? 'ywfw-tag-act' : 'ywfw-tag'"
          @click="checkTag(index, item.id)"
          v-for="(item, index) in ywfwList"
          :key="index"
        >
          {{ item.title }}
        </div>
      </div>

      <!-- <div class="case-ul">
        <div class="case-list" v-for="(item,index) in caseList" :key="index">
          <img class="case-img" :src="getImgUrl(item.image)" />
          <div class="case-name">{{item.name}}</div>
          <p class="case-indrouce">{{item.introduce}}</p>
        </div>
      </div> -->
      <div>
        <transition-group
          name="list"
          tag="ul"
          v-for="(item, index) in caseList"
          :key="index"
          :class="fwfwIndex == index ? 'case-ul' : 'case-ul-active'"
          v-show="fwfwIndex == index"
        >
          <li
            class="case-list"
            @mousemove="caseMove(items.id)"
            @mouseleave="caseOut"
            v-for="items in item"
            :key="items.name"
          >
            <img class="case-img" :src="getImgUrl(items.image)" />
            <!-- <viewer :images="item.imgShow">
				      <img v-for="(src,index) in item.imgShow"
						:src="item"
						:key="index">
				    </viewer> -->
            <transition name="fade" mode="out-in">
              <div v-if="caseIds == items.id" class="case-list-act">
                <div class="center-text">
                  <img
                    v-if="items.imgShow"
                    @click="preImgBtn(index, items.id)"
                    class="see-img"
                    src="../assets/jia.png"
                  />
                  <div class="case-name">{{ items.name }}</div>
                  <p class="case-indrouce">{{ items.introduce }}</p>
                </div>
              </div>
            </transition>
          </li>
        </transition-group>
      </div>
    </div>

    <!-- 公司简介-->
    <div class="copmey-card" id="2">
      <div class="copmey-card-left">
        <div class="ggjj-title">{{ aboutInfo.name }}</div>
        <div class="line-gsjj"></div>
        <div class="compy-indoce">
          四川途乐多户外体育运动有限公司，成立于2019年，虽然坐落于天府之国成都，却致力于服务全国，是一家专注于定制软件研发及提供行业信息化解决方案的服务商 ,我们拥有从咨询、设计、开发、测试、运维到运营的全流程软件服务能力，为提高企业信息化建设而不断耕耘。
        </div>
        <div class="gsbq-ul">
          <div class="gsbq-tag">
            <div class="gsbq-title">
              <span class="gsbq-big-text">{{
                aboutInfo.content ? aboutInfo.content[0].number : ""
              }}</span>
            </div>
            <div class="gsbq-text">
              {{ aboutInfo.content ? aboutInfo.content[0].title : "" }}
            </div>
          </div>
          <div class="gsbq-tag">
            <div class="gsbq-title">
              <span class="gsbq-big-text">{{
                aboutInfo.content ? aboutInfo.content[1].number : ""
              }}</span>
              <span class="jia">+</span>
            </div>
            <div class="gsbq-text">
              {{ aboutInfo.content ? aboutInfo.content[1].title : "" }}
            </div>
          </div>
          <div class="gsbq-tag">
            <div class="gsbq-title">
              <span class="gsbq-big-text">{{
                aboutInfo.content ? aboutInfo.content[2].number : ""
              }}</span>
              <span class="jia">+</span>
            </div>
            <div class="gsbq-text">
              {{ aboutInfo.content ? aboutInfo.content[2].title : "" }}
            </div>
          </div>
          <div class="gsbq-tag">
            <div class="gsbq-title">
              <span class="gsbq-big-text">{{
                aboutInfo.content ? aboutInfo.content[3].number : ""
              }}</span>
              <span class="gsbq-ge">个</span>
            </div>
            <div class="gsbq-text">
              {{ aboutInfo.content ? aboutInfo.content[3].title : "" }}
            </div>
          </div>
        </div>
      </div>
      <img class="gstp" :src="getImgUrl(aboutInfo.image)" />
    </div>
    <!-- 我们的团队-->
    <div class="our-team-card">
      <div class="fwal-title">{{ team.name }}</div>
      <div class="line-fwal"></div>
      <p class="fwmw-text">{{ team.introduce }}</p>
      <div v-if="team.content">
        <div class="s-content2">
          <div
            class="member-list"
            @mouseover="teamMove(index)"
            @mouseout="teamOut"
            style="position: relative"
            v-for="(item, index) in team.content"
            :key="index"
          >
            <img class="member-img" :src="getImgUrl(item.avatar)" />
            <div class="member-name">{{ item.name }}</div>
            <div class="member-zhiwei">{{ item.position }}</div>
            <transition name="fade">
              <div class="hovers" v-if="memberIds == index">
                <div class="menmber-indroce">{{ item.introduce }}</div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴-->
    <div class="hzhb-card" id="8">
      <div class="fwal-title">{{ partner.name }}</div>
      <div class="line-fwal"></div>
      <p class="fwmw-text">{{ partner.introduce }}</p>
      <div class="logo-ul" v-if="partner.content">
        <div
          class="logo-list"
          v-for="(item, index) in partner.content"
          :key="index"
        >
          <img class="hz-logo-img" :src="getImgUrl(item.image)" />
          <div class="hzhb-name">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <!-- 荣誉资质-->
    <div class="ryzz-card" id="5" style="height: 33.5rem">
      <div class="ryzz-left">
        <div class="ryzz-title">{{ honor.name }}</div>
        <div class="ryzz-line"></div>
        <div class="ryzz-indroce">
          {{ honor.introduce }}
        </div>
      </div>
      <div
        id="swiper2"
        class="swiper-container"
        style="width: 43rem; height: 16rem"
      >
        <div class="swiper-wrapper" style="width: 100%">
          <el-carousel height="16rem">
            <el-carousel-item
              v-for="(item, index) in honor.content"
              :key="index"
            >
              <div class="swiper-slide" style="width: 100%; height: 16rem">
                <img
                  class="yyzz-img"
                  @click="checkRyzz()"
                  :src="getImgUrl(item.image)"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- <div class="yyzz-ul" v-if="honor.content">
				<div class="yyzz" v-for="(item,index) in honor.content" :key="index">
					<img class="yyzz-img" :src="getImgUrl(item.image)" />
				</div>
			</div> -->
    </div>
    <!-- 底部-->
    <footer id="6">
      <div class="bottom">
        <div class="foot-up">
          <div class="foot-up-left">
            <div class="foot-up-left-up">
              <img class="foot-up-left-tel" src="../assets/tel.png" />
              <span class="foot-up-left-tel-num">客服咨询热线</span>
            </div>
            <div class="tel-number">
              {{ companyInfo.tel }}
            </div>
            <div class="tel-number">
              {{ companyInfo.phone }}
            </div>
          </div>
          <div class="gsdz">
            <div class="gsdz-title">公司地址:</div>
            <div class="gsdz-detail">{{ companyInfo.address }}</div>
          </div>
          <div class="gsdz">
            <div class="gsdz-title">电子邮箱:</div>
            <div class="gsdz-detail">{{ companyInfo.email }}</div>
          </div>
          <div class="wxkf-ul" v-if="contentInfo.CustomerService">
            <div
              class="wxkf-list"
              v-for="(item, index) in contentInfo.CustomerService.content"
              :key="index"
            >
              <img class="wxkf-img" :src="getImgUrl(item.image)" />
              <div class="wxkf-name">{{ item.position }}</div>
            </div>
          </div>
        </div>
        <div class="foot-line"></div>
        <div class="foot-dow">
          <div class="foot-dow-ul">
            <div
              class="foot-dow-list"
              v-for="(item, index) in menuList"
              :key="index"
            >
              <a style="color: white" :href="'#' + item.id">
                {{ item.title }}
              </a>
            </div>
            <!-- <div class="foot-dow-list">联系我们</div> -->
          </div>
          <div @click="gxb" class="last-text">
            途乐多 蜀ICP备19041805号-1
          </div>
        </div>
      </div>
    </footer>
    <transition name="slide-fade">
      <div class="mask" v-if="maskSwitch == true">
        <div class="ewm-box" v-if="contentInfo.CustomerService">
          <div>请添加微信或电话咨询</div>
          <div class="ewm-div-ul">
            <div
              class="ewm-div"
              v-for="(item, index) in contentInfo.CustomerService.content"
              :key="index"
            >
              <img class="ewm-img-img" :src="getImgUrl(item.image)" />
              <div class="custor-info">
                <div class="custor-info-up">{{ item.position }}</div>
                <div class="custor-info-dow">{{ item.introduce }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="close-btn" @click="maskSwitchBtn()">关闭</div>
      </div>
    </transition>
    <!-- 图片浏览 -->
    <div class="images" style="display: none" v-viewer="{ movable: false }">
      <img v-for="src in preImg" :src="getImgUrl(src)" :key="src" />
    </div>
    <div class="image" style="display: none" v-viewer="{ movable: false }">
      <img v-for="src in ryzzImg" :src="getImgUrl(src)" :key="src" />
    </div>
  </div>
</template>


<script src="https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.14.1/lodash.min.js"></script>
 <script src="https://cdn.bootcss.com/lodash.js/4.17.15/lodash.js"></script>
<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import _ from "lodash";
let sclltop = 0;
Vue.use(Viewer);
Viewer.setDefaults({
  inline:false,
  hide: function (e) {
    document.body.scrollTop = sclltop;
  },
  hidden: function (e) {
    document.body.scrollTop = sclltop;
  },
  view: function (e) {
    document.body.scrollTop = sclltop;
  },
});
export default {
  components: {},
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  created: function () {
    var vueObj = this;
    this.$on("show-dialog", function (dataList, afterSelect) {
      vueObj.$viewer.view(0);
    });
  },
  data() {
    return {
      defaultOptions: {
        zIndex: 9999,
      },

      imgsArr: [],
      host: "https://gw.x-embers.com/",
      service: {},
      checkindex: 1,
      flag: false,
      maskSwitch: false,
      scrollTop: 0,
      bannerList: [],
      firstServe: "",
      secServe: "",
      solve: [],
      ywfwList: [],
      fwfwIndex: 0,
      menuList: [],
      contentInfo: {},
      activeBtn: 0,
      caseList: [],
      checkCaseId: "1",
      caseCardids: 0,
      aboutInfo: {},
      team: {},
      partner: {},
      honor: {},
      companyInfo: {},
      description: "",
      keyword: "",
      phone: "",
      memberIds: -1,
      caseIds: -1,
      preImg: [],
      dialogVisible: false,
      swiperOption: {
        notNextTick: true,
        loop: true,
        autoplay: true,
        speed: 1000,
        direction: "horizontal",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
      },
      ryzzImg: [],
    };
  },

  metaInfo() {
    return {
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.description,
        },
        {
          vmid: "keyword",
          name: "keyword",
          content: this.keyword,
        },
      ],
    };
  },

  mounted() {
    this.getSeo();
    document.title = '四川途乐多户外体育运动有限公司';
    /* 获取滚动条 */
    window.addEventListener("scroll", this.windowScroll);
    this.getMenu();
    this.getContent();
    this.getCompanyInfo();
    var viewer = new Viewer(document.getElementById('images'), {
	url: 'data-original'
});
  },
  methods: {
    gxb(){
      
      location.href = `https://beian.miit.gov.cn`
    },
    getSeo() {
      this.$axios
        .post("https://gw.x-embers.com/api/index/seo", {})
        .then((res) => {
          this.description = res.data.data.description;
          this.keyword = res.data.data.keyword;
        });
    },
    yiru(val) {
      this.checkindex = val;
    },
    yidong() {
      this.checkindex = 1;
    },
    caseModal(index) {
      this.caseCardids = index;
    },
    windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      if (window.pageYOffset > 600) {
        this.scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      }
    },

    getImgUrl(url) {
      if (!url) {
        return "";
      }
      if (url.includes("http") || url.includes("https")) {
        return url;
      }
      return this.host + url;
    },

    maskSwitchBtn() {
      this.maskSwitch == false
        ? (this.maskSwitch = true)
        : (this.maskSwitch = false);
      this.scroolTab();
      console.log("开关", this.maskSwitch);
    },
    scroolTab() {
      if (this.maskSwitch == false) {
        this.move();
      } else {
        this.stop();
      }
    },
    move() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    stop() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    getMenu() {
      this.$axios({
        method: "get",
        url: "https://gw.x-embers.com/api/index/menu",
        params: {},
      }).then(
        (res) => {
          this.menuList = res.data.data;
          // console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getContent() {
      this.$axios({
        method: "get",
        url: "https://gw.x-embers.com/api/index/content",
        params: {},
      }).then(
        (res) => {
          this.contentInfo = res.data.data;
          this.bannerList = this.contentInfo.banner.content;
          // console.log(this.bannerList, "bannerList");
          this.service = this.contentInfo.service;
          this.firstServe = this.service.introduce.split("\n");
          // console.log("ssssddffg", this.firstServe);
          this.secServe = this.service.introduce.substr(
            71,
            this.service.introduce.length - 1
          );
          this.solve = this.contentInfo.solve.content;
          //this.caseList=this.contentInfo.ServiceCase.content
          this.ywfwList = this.contentInfo.ServiceCase.type_map;
          this.aboutInfo = this.contentInfo.about;
          this.team = this.contentInfo.team;
          this.partner = this.contentInfo.Partner;
          this.honor = this.contentInfo.Honor;
          if (this.contentInfo.Honor.content) {
            this.contentInfo.Honor.content.map((item) => {
              this.ryzzImg.push(item.image);
            });
          }
          for (let i = 1; i <= this.ywfwList.length; i++) {
            let arr = this.contentInfo.ServiceCase.content.filter((item) => {
              return item.type.includes(String(i));
            });
            this.caseList.push(arr);
          }
          for (let i = 0; i < this.caseList.length; i++) {
            this.caseList[i].map((item, i) => {
              item.id = i;
              if (item.item_show != "" && item.item_show.length != 0) {
                // console.log("you");
                let newStr = "";
                newStr = item.item_show;
                item.imgShow = newStr.split(",");
              } else {
                console.log("没有");
              }
            });
          }
          // console.log(this.caseList);
          // for(let i in caseTag){
          //     this.ywfwList.push({[i]:caseTag[i]})
          // }
          //this.ywfwList=Array.from(caseTag)
          //this.ywfwList=this.contentInfo.ServiceCase.type_map
          // console.log("选项卡112223", this.ryzzImg);
          // console.log("选项卡id", this.checkCaseId);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    preImgBtn(index, ids) {
      console.log("当前下标", ids);
      this.preImg = this.caseList[index][ids].imgShow;
      const viewer = this.$el.querySelector(".images").$viewer;
      console.log(viewer);
      viewer.show();
      document.body.scrollTop = this.scrollTop;
      sclltop = this.scrollTop;
      console.log("当前下标", this.preImg);
    },
    checkRyzz() {
      const viewer = this.$el.querySelector(".image").$viewer;
      viewer.show();
    },
    closeImgPreview() {
      this.dialogVisible = false;
    },
    getCompanyInfo() {
      this.$axios({
        method: "get",
        url: "https://gw.x-embers.com/api/index/companyInfo",
        params: {},
      }).then(
        (res) => {
          this.companyInfo = res.data.data;
          // console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    checkTag(index, id) {
      // this.caseList = [];
      this.checkCaseId = id;
      this.fwfwIndex = index;
      console.log(this.fwfwIndex);
      this.caseList[index].map((item, i) => {
        item.id = i;
        if (item.item_show != "" && item.item_show.length != 0) {
          // console.log("you");
          let newStr = "";
          newStr = item.item_show;
          item.imgShow = newStr.split(",");
        } else {
          console.log("没有");
        }
      });
      // this.flag = false;
      // setTimeout(() => {
      //   this.flag = true;
      // });

      // this.caseList = this.contentInfo.ServiceCase.content.filter((item) => {
      //   return item.type.includes(this.checkCaseId);
      // });
      // this.caseList = _.shuffle(this.caseList);
      // console.log(this.caseList);
      // this.caseList.map((item, i) => {
      //   item.id = i;
      //   if (item.item_show != "" && item.item_show.length != 0) {
      //     let newStr = "";
      //     newStr = item.item_show;
      //     item.imgShow = newStr.split(",");
      //   } else {
      //     console.log("没有");
      //   }
      //   // console.log("you11", this.caseList);
      // });
      // console.log(this.caseList);
    },

    show() {
      const viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },

    teamMove(index) {
      this.memberIds = index;
    },
    teamOut() {
      this.$set(this, "memberIds", -1);
    },
    caseMove(id) {
      this.caseIds = id;
    },
    caseOut() {
      this.$set(this, "caseIds", -1);
    },
    checkMenu(selector, index) {
      this.activeBtn = index;
      // document.querySelector("#app-root").scrollTop = this.$el.querySelector(selector).offsetTop;
    },
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.windowScroll);
  },
};
</script>
<style>
@import "./home.css";
.case-ul {
  animation-name: don;
  animation-duration: 0.6s;
}
@keyframes don {
  0% {
    transform: rotatex(90deg);
  }
  100% {
    transform: rotatex(0deg);
  }
}
.case-ul-active {
  opacity: 0;
  transition: all 0.5s;
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter
  /* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-leave-to {
  opacity: 0;
  transition: all 0.01s;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue